<div class="row">
    <div class="col">
        <div class="row">
            <div class="col">
                <div class="d-flex w-100 justify-content-between">
                    <h6 class="mb-1 main-blue bolded">
                        {{ item.mainMemberFirstName }}
                        {{ item.mainMemberLastName }} [{{ item.mainMemberId }}]
                    </h6>
                </div>
            </div>
        </div>
        @if (hasChildren) {
            <div class="row mt-3 mb-2">
                <div class="col">
                    <div class="d-flex font-weight-bold">
                        {{ "MembershipList.ChildrenLabel" | translate }}
                    </div>
                </div>
            </div>
        }
        @if (!hasChildren) {
            <div class="row mt-3 mb-2">
                <div class="col">
                    <div class="d-flex font-weight-bold">
                        {{ "MembershipList.NoChildrenLabel" | translate }}
                    </div>
                </div>
            </div>
        }
        @for (child of item.children; track child) {
            <div class="row no-gutters">
                <div class="col">
                    <div class="pl-3">
                        {{ child.firstName }} {{ child.lastName }}
                    </div>
                </div>
                <div class="col-auto">
                    <div>
                        @if (!child.hasNoLimit) {
                            <button
                                class="btn btn-action btn-light width-130"
                                bcClick
                                (clicked)="onAddNoLimit(child)"
                            >
                                {{ "MembershipList.AddNoLimit" | translate }}
                            </button>
                        }
                        @if (child.hasNoLimit) {
                            <button
                                class="btn btn-action btn-danger width-130"
                                bcClick
                                (clicked)="onRemoveNoLimit(child)"
                            >
                                {{ "MembershipList.RemoveNoLimit" | translate }}
                            </button>
                        }
                    </div>
                </div>
                <hr />
            </div>
        }
    </div>
</div>
